// extracted by mini-css-extract-plugin
export default {"central":"loader_central__oUn-J","container":"loader_container__1BcbN","loader":"loader_loader__cLoez","load5":"loader_load5__s3OX-","spinner":"loader_spinner__WYaXO"};